import React, { useCallback, useEffect, useRef, useState } from 'react'
//IMAGENES
import URLFONDODATOSPERSONALES from "assets/img/ActualizacionDatosPersonales.svg"
import URLENCABEZADO from "assets/img/BannerAcDP.svg"
import URLLATERAL from "assets/img/imag lateral.svg"


//bootstrap
import { Modal, ModalBody, FormGroup, Input, Label, Button, Container, Row, Col } from "reactstrap"
import ModalCargando from './ModalCargando'
import { ObtenerFechaFormatoLocal, ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions'
import { useHistory } from 'react-router'

//rutas datos personales
import dashRoutes from "routes";
import { UpdateDateFechaConfirmacionActualizacionDatosGenerales, UpdateDateUltimoCambioDatosGenerales } from 'functions/RequestFunctions'
import { UserData } from 'components/Sidebar/Sidebar_Principal'
import ModalHeader from 'react-bootstrap/esm/ModalHeader'
import { opcionesSideBar, useSideBarContext } from 'Context/SideBarContext'
import { KEY_EXPIRE_MODALACTUALIZARDATOSPERSONALES, KEY_SHOWMODALACTUALIZAR_DATOSPERSONALES, RemoveLocalStorageElements, UpdateExpeditionTimeLocalStorage } from 'functions/LocalStorageFunctions'

export type PropsModalActualizarDatosPers = {
    show: boolean,
    fechaActualizacion: string
    tokenUser: string
    onClose: () => void
}

function HandleLocalStorage() {
    var fechaexpedicion = localStorage.getItem(KEY_EXPIRE_MODALACTUALIZARDATOSPERSONALES);
    var fechaactual = new Date();
    var expiro = fechaexpedicion !== null && fechaactual > new Date(fechaexpedicion)
    if (expiro) {
        RemoveLocalStorageElements([KEY_SHOWMODALACTUALIZAR_DATOSPERSONALES])
    }
    var SoloDioContinuar = localStorage.getItem(KEY_SHOWMODALACTUALIZAR_DATOSPERSONALES)

    return (SoloDioContinuar !== null && SoloDioContinuar === "SI" || SoloDioContinuar === null) && (expiro || fechaexpedicion == null);

}




function ModalActualizarDatosPers(props: PropsModalActualizarDatosPers) {


    const [loadingImage, setloadingImage] = useState<boolean>(true)
    const [checkActualizar, setcheckActualizar] = useState(false)
    const [checkActualizado, setcheckActualizado] = useState(false)
    const [errorAccion, seterrorAccion] = useState<string>("")


    const { setsubMenuDatosPersonales,setsubMenu,setvaloressubMenu, routes_usuarios_generales,setvaloressubMenuNieto,setsubMenuNieto,NOMBRE_OPCION_DATOS_PERSONALES} = useSideBarContext();
    const history = useHistory();


    const banderaMostrarDeNuevo = HandleLocalStorage();

    var imagenENCABEZADO = new Image();
    imagenENCABEZADO.addEventListener('load', function () {
        setloadingImage(false)
    });
    imagenENCABEZADO.src = URLENCABEZADO;
    var imagenLATERAL = new Image();
    imagenLATERAL.src = URLLATERAL

    function handleCheckBox(isChecked: boolean, nameInputCheck: string) {
        //checkEstaActualizada,checkDeseoActualizar
        if (nameInputCheck === "checkEstaActualizada") {
            setcheckActualizado(isChecked)
        }
        else if (nameInputCheck === "checkDeseoActualizar") {
            setcheckActualizar(isChecked)
        }
    }

    const HandleClickContinuar = useCallback(async () => {
        if (checkActualizar) {
            localStorage.setItem("SoloContinuoModal", "NO")
            UpdateExpeditionTimeLocalStorage(KEY_EXPIRE_MODALACTUALIZARDATOSPERSONALES,1);


            var infoRuta = dashRoutes.find((valueRuta, indiceRuta) => valueRuta.name === "DATOS GENERALES")
            //history.replace(`/admin${infoRuta?.path}`)
            window.location.replace("https://th.espol.edu.ec/user/datos-personales/datos-generales");
            setsubMenuDatosPersonales(true);
            setsubMenu(true)
            setsubMenuNieto(true)

            setvaloressubMenu(routes_usuarios_generales)
            var rutasSubMenuNieto:opcionesSideBar|undefined= routes_usuarios_generales.find(ruta => ruta.titulo === NOMBRE_OPCION_DATOS_PERSONALES);
            if(rutasSubMenuNieto !== undefined){
                setvaloressubMenuNieto(rutasSubMenuNieto.entries);
            }
            
        }
        else if (checkActualizado) {
            localStorage.setItem(KEY_SHOWMODALACTUALIZAR_DATOSPERSONALES, "NO")
            UpdateExpeditionTimeLocalStorage(KEY_EXPIRE_MODALACTUALIZARDATOSPERSONALES,1);


            var status = await UpdateDateFechaConfirmacionActualizacionDatosGenerales(props.tokenUser)
            if (status === 200) {
                if (typeof (props.onClose) === "function") {
                    props.onClose();
                }
            }
            else {
                seterrorAccion("Ha ocurrido un error, por favor actualice la página e intente de nuevo");
            }
        }
        else {
            localStorage.setItem(KEY_SHOWMODALACTUALIZAR_DATOSPERSONALES, "SI")
            UpdateExpeditionTimeLocalStorage(KEY_EXPIRE_MODALACTUALIZARDATOSPERSONALES,1);

            if (typeof (props.onClose) === "function") {
                props.onClose();
            }
        }
    },
        [checkActualizar, checkActualizado])

    if (!loadingImage) {
        return (
            <div>

                <Modal
                    id="ModalActualizarDatosPers"
                    isOpen={(props.show && banderaMostrarDeNuevo) || errorAccion !== ""}
                    scrollable={true}
                    size={"xl"}
                    fullscreen={"xl"}
                    // aria-labelledby="contained-modal-title-vcenter"
                    centered
                    onClosed={() => props.onClose()}
                    contentClassName="custom-modal-actualizarDP"
                    modalClassName="multiple-background"
                    style={{
                        backgroundImage: `url(${imagenENCABEZADO.src}),url(${imagenLATERAL.src})`,
                        backgroundRepeat: "no-repeat,no-repeat",
                        backgroundSize: "100% , 40%",
                        backgroundPosition: "top right,left bottom 100%",
                        backgroundOrigin: "content-box,content-box",
                        backgroundColor: "white"

                    }}

                >

                    <ModalBody>
                        <div className="parentContentBodyActualizar-DP mt-5">
                            <div className=" text-modal-actualizardp">
                                <strong>Usted es responsable</strong> de la veracidad y actualización de los datos proporcionados en esta plataforma
                            </div>
                            <div className="modal-actualizardp-textfecha">
                                La última actualización la realizó {ObtenerFechaFromIsoFormat(props.fechaActualizacion)}
                            </div>
                            <div className="parentFormAct">
                                <Container>
                                    <form >
                                        <FormGroup
                                            className="justify-content-center align-items-center"
                                        >
                                            <FormGroup
                                                row
                                            >
                                                <FormGroup check>
                                                    <Input
                                                        name="checkEstaActualizada"
                                                        type="checkbox"
                                                        onChange={(e) => handleCheckBox(e.target.checked, "checkEstaActualizada")}
                                                        value={checkActualizado}
                                                        disabled={checkActualizar}
                                                    />
                                                    {' '}
                                                    <Label check className="labelModalActualizarDP">
                                                        Confirmo que la información de mis datos personales se encuentra actualizada
                                                    </Label>
                                                </FormGroup>
                                            </FormGroup>

                                            <FormGroup
                                                row
                                            >
                                                <FormGroup check>
                                                    <Input
                                                        name="checkDeseoActualizar"
                                                        type="checkbox"
                                                        onChange={(e) => handleCheckBox(e.target.checked, "checkDeseoActualizar")}
                                                        value={checkActualizar}
                                                        disabled={checkActualizado}

                                                    />
                                                    {' '}
                                                    <Label check className="labelModalActualizarDP">
                                                        Deseo actualizar mis datos personales
                                                    </Label>
                                                </FormGroup>
                                            </FormGroup>

                                        </FormGroup>



                                    </form>
                                    <Row className="justify-content-center">
                                        <Col sm={12} >
                                            <div className="small-error">{errorAccion}</div>
                                        </Col>
                                    </Row>
                                    <Row className="justify-content-center">
                                        <Col sm={12} md={4} lg={2} xl={3}>
                                            <Button className="btnEspolPrimary" type="button" onClick={() => { HandleClickContinuar() }}>Continuar</Button>
                                        </Col>
                                    </Row>
                                </Container>

                            </div>


                        </div>

                    </ModalBody>

                </Modal>
            </div >

        )
    }
    else if (!loadingImage && props.show) {
        return (
            <ModalCargando
                show={true}
                onClose={() => false}
                size="sm"
            />
        )
    }
    else {
        return <div></div>
    }



}

export default ModalActualizarDatosPers


